module.exports = __webpack_public_path__ + "img/firma.b5c349e6.jpg";